export default __webpack_public_path__ + "static/media/80_mobile.3af4dbf0.jpg";